// forms/_FormMessage.tsx
import Icon from '@publishing/components/ui/Icon';
import { StatusDelete, StatusNotice } from '@publishing/components/ui/SvgSprite';
import styles from './_FormMessage.module.scss';  
interface FormMessageProps {
  errorMessage?: string;
  helperMessage?: string;
}

export default function FormMessage({ errorMessage, helperMessage }: FormMessageProps) {
  if (errorMessage) {
    return (
      <p className={styles.error_msg}>
        <Icon name={StatusDelete} theme="fill" size={16} />
        {errorMessage}
      </p>
    );
  }

  if (!errorMessage && helperMessage) {
    return (
      <p className={styles.helper_msg}>
        <Icon name={StatusNotice} theme="fill" size={14} />
        {helperMessage}
      </p>
    );
  }

  return null;
}